import { useEffect, useState } from 'react';
import { AGENT_APPROVAL_POLL_INTERVAL_MS, AGENT_APPROVAL_POLL_MAX_DURATION_MS } from '../constants/polling';
export const useAgentApprovalPolling = ({
  hasPendingAgentStep,
  approvableObjectId
}) => {
  const [pollingExpired, setPollingExpired] = useState(false);

  // Reset the budget whenever a fresh polling window opens: a new approvable
  // object, or a change in the pending state.
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setPollingExpired(false);
  }, [approvableObjectId, hasPendingAgentStep]);
  const shouldPoll = hasPendingAgentStep && !pollingExpired;
  useEffect(() => {
    if (!shouldPoll) {
      return undefined;
    }
    const capTimerId = setTimeout(() => {
      setPollingExpired(true);
    }, AGENT_APPROVAL_POLL_MAX_DURATION_MS);
    return () => clearTimeout(capTimerId);
  }, [shouldPoll, approvableObjectId]);
  return shouldPoll ? AGENT_APPROVAL_POLL_INTERVAL_MS : 0;
};